import { Menu } from '../interfaces';
import { FIRST_ZERO_HOUR, menuList, MIDNIGHT_HOUR, ZERO_MINUTES, skusNotForSale } from '../global';
import { FormGroup } from '@angular/forms';
import { Address, Carrier } from '../models';
import { Constants } from '../configs';
import { environment } from '../../../environments/environment';
import moment from 'moment';
import { Country, PROMART_ECUADOR_CODE, SUPERMERCADOS_CODE, igvNumber, igvNumberDefault, maxLengthyCountry } from '../configs/company.config';

export function formatDate(date: Date) {
  if (!date) {
    return null;
  }
  return (
    date.getFullYear() +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + date.getDate()).slice(-2)
  );
}

export function parseDate(date: string) {
  if (!date || date === '') {
    return '';
  }
  const dates = date.split('-');
  return new Date(parseFloat(dates[0]), parseFloat(dates[1]) - 1, parseFloat(dates[2]));
}


export function parseDateV2(date: string): Date | null {
  if (!date) { return null; }
  const [year, month, day] = date.split('-').map(Number);
  return new Date(year, month - 1, day);
}


export function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function resetForm(form: FormGroup) {
  form.reset();
  Object.keys(form.controls).forEach(key => {
    form.controls[key].setErrors(null);
  });
}

export function getCurrentMenu(siveNav?: boolean) {
  const urls = document.location.pathname.substring(1).split('/');
  const currentPage = siveNav ? ('/' + urls.join('/')) : ('/' + urls[0] + (urls.length > 1 ? '/' + urls[1] : ''));
  let currentMenu: Menu = null;
  for (const menu of menuList) {
    if (menu.link === currentPage) {
      currentMenu = menu;
      break;
    } else if (menu.subMenuList) {
      for (const submenu of menu.subMenuList) {
        let page = '';
        if (submenu.link.includes('/:')) {
          let links: any[] = submenu.link.substring(1).split('/');
          links[links.length - 1] = urls[urls.length - 1];
          page = '/' + links.join('/');
        }
        if (submenu.link === currentPage || page === currentPage) {
          currentMenu = submenu;
          break;
        }
      }
    }
  }
  return currentMenu;
}


export function typeConfigurate(value: string) {
  return value === 'crear' ? true : false;
}

export function objectToParams(data: object): string {
  return Object.keys(data)
    .filter(key => data[key] !== null && data[key] !== undefined)
    .map(key => `${key}=${encodeURIComponent(data[key])}`)
    .join('&');
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * Función que retorna una concatenación de código para identificar una dirección
 * @param element Dirección
 */
export function getIdAddress(element: Address): string {
  return element ? `${element.ubigeoCode}${element.address}${element.number}` : '';
}

export const isEmpty = (value: any): any => {
  if (value === undefined || value === null) {
    return '';
  }
  return value;
};

export const isEmptyObject = (objct: any) => {
  for (const member in objct) {
    if (objct[member] === null || objct[member] === '' || objct[member] === undefined) {
      delete objct[member];
    }
  }
  return objct;
};

export function isObjectEmpty(obj) {
  if (obj === null || obj === undefined) {
    return true;
  }

  if (typeof obj !== 'object') {
    return false;
  }

  return Object.keys(obj).length === 0;
}

export function structureFilter(filterInput) {
  Object.keys(filterInput).forEach(key => {
    if (filterInput[key] === '' || filterInput[key] === null) {
      delete filterInput[key];
    }
  });
}

export function displayAutocomplete(selected: any, item: string): string | undefined {
  return selected ? selected[item] : undefined;
}

export function patternDocumentType(type): string | undefined {
  const user = JSON.parse(localStorage.getItem(environment.sessionAuth));

  let patter = ''
  switch (type) {
    case Constants.Customer.DOCUMENT_TYPES.DNI:
      if (user.user.country === Country.PERU) {
        patter = '[0-9]{8,8}';
      } else {
        patter = '[0-9]{10,10}';
      }
      break;
    case Constants.Customer.DOCUMENT_TYPES.PASSPORT:
    case Constants.Customer.DOCUMENT_TYPES.FOREIGN_DOCUMENT:
      patter = '[a-zA-Z0-9]{9,12}';
      break;
    case Constants.Customer.DOCUMENT_TYPES.RUC:
      if (user.user.country === Country.PERU) {
        patter = '[0-9]{11,11}';
      } else {
        patter = '[0-9]{13,13}';
      }
      break;
    case Constants.Customer.DOCUMENT_TYPES.OTHER:
      patter = '[a-zA-Z0-9]{6,12}';
      break;
  }
  return patter;
}

export function transformAccordingToDecimals(value, numberOfDecimals): any {
  return Number.isInteger(value) ? Number(value) : Number(Number(value).toFixed(numberOfDecimals));
}

export function parseAttributes(attributes: Object): any[] {
  const att = []
  if (!attributes) {
    return [];
  }
  Object.keys(attributes).forEach(item => {
    att.push({
      attribute: attributes[item],
      attributeValue: item
    });
  });
  return att;
}


export function validatePrice(price, priceLine): number {
  return Number(price ? price : priceLine)
}

export function countDecimals(value) {
  if (Math.floor(value) === value) return 0;
  return value.toString().split(".")[1].length || 0;
}

export function truncateValue(number) {
  if (number === null || number === undefined || isNaN(number)) {
    return 0;
  }
  const numOfDecimals = countDecimals(number);
  if (numOfDecimals > 2 && numOfDecimals < 5) {
    return Math.trunc(number * 100) / 100;
  } else {
    const valueWithRounding = transformAccordingToDecimals(number, 4);
    const value = countDecimals(valueWithRounding) > 2
      ? (Math.trunc(valueWithRounding * 100) / 100)
      : valueWithRounding;
    return value;
  }
}

export function getNumberOfDecimalsForMeasurableProducts(element: any) {
  return element && element.conversionFactor ? (element.conversionFactor.toString().length - 1) : 3;
}


export function removeNullValues(obj): any {
  var propNames = Object.getOwnPropertyNames(obj);
  for (var i = 0; i < propNames.length; i++) {
    var propName = propNames[i];
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}

export function getHourDeliveryWindowTo(startHourDeliveryWindowFrom: string) {
  let startHourDeliveryWindowTo: string = "";
  if (!startHourDeliveryWindowFrom) {
    return null;
  }
  else {
    let hora: number = +startHourDeliveryWindowFrom.substring(0, 2) + 1;
    if (hora == 24)
      startHourDeliveryWindowTo = MIDNIGHT_HOUR
    else
      startHourDeliveryWindowTo = hora < 10 ? FIRST_ZERO_HOUR + hora + ZERO_MINUTES : hora.toString() + ZERO_MINUTES
    return startHourDeliveryWindowTo;
  }
}

export function isForSale(input, type) {
  let isForSale: Boolean = true;
  switch (type) {
    case 'sku':
      if (skusNotForSale.find(it => it.sku === input)) {
        isForSale = false;
      }
      break;
    case 'eanCode':
      if (skusNotForSale.find(it => it.eanCode === input)) {
        isForSale = false;
      }
      break;
    default:
      break;
  }
  return isForSale;
}

export function showChannel(saleChannel: string) {
  const channels = Constants.ReportConfig.CHANNELS;
  const channel = channels.find(channel => channel.id == saleChannel);
  return channel ? channel.text : '';
};


export function formatDateStart(date): string {
  return date ? moment(date).format('YYYY-MM-DD') + ' 00:00:00' : null;
}

export function orderingEntity(a, b) {
  return b.entityName > a.entityName ? -1 : 1
}
export const isBlank = (str: string) => {
  return (!str || /^\s*$/.test(str));
};

export function isSupportUser(): Boolean {
  const userSession = JSON.parse(localStorage.getItem(environment.sessionAuth)).user;
  const userSupport = Constants.ConfigUser.userSupport;
  return userSession.username.toLowerCase().includes(userSupport.toLowerCase());
}

export function isSPSACompanyUser(): boolean {
  const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
  return session
    && session.user
    && session.user.entity
    && session.user.entity.company
    && session.user.entity.company.code === SUPERMERCADOS_CODE
}

export function isHESACompanyUser(): boolean {
  const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
  return session
    && session.user
    && session.user.entity
    && session.user.entity.company
    && session.user.entity.company.code === PROMART_ECUADOR_CODE
}

export function convertToStringsAndCompare(value1: any, value2: any) {
  return JSON.stringify(value1) == JSON.stringify(value2);
}

export function isEmptyString(str) {
  return str == null || str.trim() === '';
}

export function isNotDefaultAndEmpty(addressId: any) {
  return !isEmptyString(addressId) && addressId !== 'default';
}

export function getMaxLegthCellNumber(): number {
  const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
  return maxLengthyCountry.fieldCellNumber[user.user.country];
}


export function getIgvNumber(): number {
  const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
  return igvNumber[user.user.country];
}

export function getIgvNumberDefault(user?): number {
  if (user) {
    return igvNumberDefault[user.country];
  }
  user = JSON.parse(localStorage.getItem(environment.sessionAuth));
  return igvNumberDefault[user.user.country];
}

export function sortCarriers(carriers: Carrier[]): Carrier[] {
  return carriers.sort((a, b) => {
    if (a.businessName > b.businessName) {
      return 1;
    }
    if (a.businessName < b.businessName) {
      return -1;
    }
    return 1;
  })
}

export function getIfUseCentralizedStock(saleEntityCode: string): boolean {
  let enableCes: boolean = JSON.parse(localStorage.getItem(environment.useCentralizedStock));
  const storageEntity = localStorage.getItem(environment.useCentralizedStockEntity);
  const configEntity: any[] = storageEntity ? JSON.parse(storageEntity) : null;
  if (enableCes && configEntity && configEntity.length > 0) {
    const existConfigEntity = configEntity.find(elemt => Object.keys(elemt).length > 0);
    if (existConfigEntity) {
      //en caso de que este habilitado el ces se valida la entidad este configurada
      const findEntity = configEntity.find(module => module.entityCode === saleEntityCode)
      enableCes = findEntity != undefined;
    }
  }
  return enableCes;
}

export function parseDatetoString(date: string) {
  if (!date || date === '') {
    return '';
  }
  const dates = date.split('-');
  return dates[2] + "-" + dates[1] + "-" + dates[0];
}


export function convertDateToIso(date: string): string {
  const [day, month, year] = date.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day, 5, 0, 0, 0)).toISOString();
}